/**
 * m2m controller mixin
 */

/**
 * m2mCtrlMixinFactory
 * returns m2mCtrlMixin mixin factory
 *
 * @class m2mCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:m2mCtrlMixinFactory
 */
/* @ngInject */
export default function m2mCtrlMixinFactory (Entity) {
  function getCallback (callback, name) {
    if (callback) {
      return typeof callback === 'function'
        ? callback
        : callback[name]
    }
  }

  /**
   * Mixin with common functions to work with m2m fields
   *
   * @mixin m2mCtrlMixin
   * @memberof mwApp/common
   * @see mwApp/common
   * @name mwApp/common.mixin:m2mCtrlMixin
   *
   * @param  {String|models.Entity} entity - entity or entity name
   * @param  {String}  field    - entity field name
   * @param  {String} [vmField] - controller field name, by default = entity field name
   * @param  {Object|Function} [callback] - callback, called after each method,
   *                                        or object with callbacks by names select|deselect|reset
   * @return {Object}
   */
  function m2mCtrlMixin (entity, field, vmField, callback) {
    vmField = vmField || field
    var plural = field.charAt(0).toUpperCase() + field.slice(1) // capitalize first letter
    var singular = plural
      .replace(/ies$/, 'y') // replace last 'ies' to 'y'
      .replace(/s$/, '') // or remove last 's'
    var mixin = {}

    // add method to add Smth to Field
    // like 'selectNetwork' or 'selectAddon'
    mixin['select' + singular] = function (what) {
      var e = entity instanceof Entity ? entity : this[entity]
      if (what && e) {
        e['_add' + singular](what, this[vmField])

        var fn = getCallback(callback, 'select')
        if (fn) {
          fn.apply(this, arguments)
        }
      }
    }

    // add method to remove Smth from Field
    // like 'deselectNetwork' or 'deselectAddon'
    mixin['deselect' + singular] = function (what, form) {
      if (form) { form.$setDirty() }
      var e = entity instanceof Entity ? entity : this[entity]
      if (what && e) {
        e['_remove' + singular](what, this[vmField])

        var fn = getCallback(callback, 'deselect')
        if (fn) {
          fn.apply(this, arguments)
        }
      }
    }

    // add method to reset Field
    // like 'resetNetworks' or 'resetAddons'
    mixin['reset' + plural] = function () {
      var e = entity instanceof Entity ? entity : this[entity]
      if (e) {
        e['_reset' + plural](this[vmField])

        var fn = getCallback(callback, 'reset')
        if (fn) {
          fn.apply(this, arguments)
        }
      }
    }

    return mixin
  }

  return m2mCtrlMixin
}
